import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { OriginalDataContextProvider } from './contexts/OriginalDataContext';
import { CurrentDataContextProvider } from './contexts/CurrentDataContext';
import { UserContextProvider } from './contexts/UserContext';
import { RoutesContextProvider } from './contexts/RoutesContext';
import { LanguageContextProvider } from './contexts/LanguageContext';
import ReactDOMClient from 'react-dom/client';
import "./i18n/config";
import { PublicClientApplication, EventType, EventMessage, AuthenticationResult } from "@azure/msal-browser";
import { ClearContextsContextProvider } from './contexts/ClearContextsContext';
import { ToastContainer } from 'react-toastify';
import { RequiredAccomplishmentsContextProvider } from './contexts/RequiredAccomplishmentsContext';
import { ErrorContextProvider } from './contexts/ErrorContext';
import { msalConfig } from "./config/authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    console.log('EVENT', event);
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
});

const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container as HTMLElement);

// console.log = () => { };

root.render(
  <Router>
    <ErrorContextProvider>
      <UserContextProvider>
        <RoutesContextProvider>
          <LanguageContextProvider>
            <OriginalDataContextProvider>
              <CurrentDataContextProvider>
                <RequiredAccomplishmentsContextProvider>
                  <ClearContextsContextProvider>
                    <ToastContainer />
                    <App pca={msalInstance} />
                  </ClearContextsContextProvider>
                </RequiredAccomplishmentsContextProvider>
              </CurrentDataContextProvider>
            </OriginalDataContextProvider>
          </LanguageContextProvider>
        </RoutesContextProvider>
      </UserContextProvider>
    </ErrorContextProvider>
  </Router>
);